/* istanbul ignore file */
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing } = themeVariables;

export const root = css`
  position: absolute;
  right: var(${spacing.sm});
  bottom: var(${spacing.sm});
  box-shadow: 0 0 4px 0 rgba(14, 14, 17, 0.1);

  /*
    The pill sits over photography, so it needs an opaque background, but Button's secondary
    variant is deliberately transparent and there is no solid variant to ask for instead.
    Button's own styles are injected after these, so a plain single-class override here would
    win or lose on render order alone: doubling the class with && settles it by specificity.
    Hover keeps !important because Button's hover rule carries four selectors of its own.
  */
  && {
    background-color: var(${colors.surface.default});

    &:hover {
      background-color: var(${colors.surface.default}) !important;
    }
  }
`;
